import {Routes} from '@angular/router';
import {HomeComponent} from './pages/home/home.component';
import {MenuComponent} from './components/menu/menu.component';
import {authGuard} from './guards/auth-guard';
import {LogoutComponent} from './pages/logout/logout.component';
import {DocumentsComponent} from './pages/documents/documents.component';
import {BusStationsComponent} from './pages/bus-stations/bus-stations.component';
import {FinexsPrivacyPolicyComponent} from './pages/finexs-privacy-policy/finexs-privacy-policy.component';
import {CallbackComponent} from './pages/callback/callback.component';
import {ExternalCallsComponent} from './pages/external-calls/external-calls.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: '',
    component: MenuComponent, children: [
      {
        path: 'home',
        component: HomeComponent,
      },
      {
        path: 'sell',
        loadChildren: () => import('./pages/sell/sell-module').then(m => m.routes)
      },
      {
        path: 'commands',
        loadChildren: () => import('./pages/commands/commands-module').then(m => m.routes)
      },
      {
        path: 'sell-parcel',
        loadChildren: () => import('./pages/sell-parcel/sell-parcel-module').then(m => m.routes)
      },
      {
        path: 'payments',
        loadChildren: () => import('./pages/payments/payments-module').then(m => m.routes)
      },
      {
        path: 'parcels',
        loadChildren: () => import('./pages/parcels/parcels-module').then(m => m.routes)
      },
      {
        path: 'traject-lines',
        loadChildren: () => import('./pages/traject-lines/traject-lines-module').then(m => m.routes)
      },
      {
        path: 'bus-stations',
        component: BusStationsComponent
      },
      {
        path: 'external-calls',
        component: ExternalCallsComponent
      },

      {
        path: 'documents',
        component: DocumentsComponent
      },
      {
        path: 'passengers',
        loadChildren: () => import('./pages/passengers/passengers-module').then(m => m.PASSENGERS_ROUTES)
      },
      {
        path: 'notifications',
        loadChildren: () => import('./pages/notifications/notifications-module').then(m => m.routes)
      },
      {
        path: 'sales',
        loadChildren: () => import('./pages/sales/sales-module').then(m => m.routes)
      },

      {
        path: 'stats',
        loadChildren: () => import('./pages/stats/stats-module').then(m => m.routes)
      },
      {
        path: 'trajects',
        loadChildren: () => import('./pages/trajects/trajects-module').then(m => m.routes)
      },
      {
        path: 'departures',
        loadChildren: () => import('./pages/departures/departures-module').then(m => m.routes)
      },

      {
        path: 'parcel-types',
        loadChildren: () => import('./pages/parcel-types/parcel-types-module').then(m => m.routes)
      },
      {
        path: 'employees',
        loadChildren: () => import('./pages/employees/employees-module').then(m => m.routes)
      },
      {
        path: 'bus-models',
        loadChildren: () => import('./pages/bus-models/bus-models-module').then(m => m.routes)
      },
      {
        path: 'buses',
        loadChildren: () => import('./pages/bus/bus-module').then(m => m.routes)
      },
      {
        path: 'royalties',
        loadChildren: () => import('./pages/royalties/royalties-module').then(m => m.routes)
      }



    ],
    canActivate: [authGuard],
    canActivateChild: [authGuard]
  },
  {
    path: 'callback',
    component: CallbackComponent
  },
  {
    path: "logout",
    component: LogoutComponent
  },
  {path: '5959a056-0963-447b-9dff-9d5880d78152/privacy-policy', component: FinexsPrivacyPolicyComponent },
  {
    path: '**',
    redirectTo: 'home',
  },
];
